import { render, staticRenderFns } from "./cate_in_list.mpx?vue&type=template&id=49af3de8&scoped=true&component=true&componentId=cate_in_list57520d6c"
import script from "./cate_in_list.mpx?vue&type=script&lang=js&component=true&componentId=cate_in_list57520d6c"
export * from "./cate_in_list.mpx?vue&type=script&lang=js&component=true&componentId=cate_in_list57520d6c"
import style0 from "./cate_in_list.mpx?vue&type=style&index=0&id=49af3de8&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m57520d6c%22%7D&component=true&componentId=cate_in_list57520d6c"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49af3de8",
  null
  
)

export default component.exports